<template>
	<header>
		<h1>
			<a href="/">
				<svg version="1.1" x="0px" y="0px" width="62.5px" height="62.5px" viewBox="0 0 62.5 62.5" enable-background="new 0 0 62.5 62.5" xml:space="preserve">
				<path fill="#424242" d="M45.7,27.8c0,0.4,0,0.8,0,1.2c0,9.1-2.8,13.9-6.2,16.5c-4.4,3.2-10.1,3.5-15,3.5h-5.1v-8.5L2.6,48.7v13.8
					h26.3c3.8,0,7-0.2,10.7-1c8.2-1.9,13.1-6.3,15.3-8.7c3.6-4.2,7.7-11.7,7.7-24.3c0-3.2-0.3-6-0.7-8.4L45.7,27.8z"/>
				<path fill="#424242" d="M16.9,41.7V14.1h6.7c3.2,0,6.1-0.1,9.2,0.9c3.6,1.1,5.6,3.4,6.5,4.6c2.3,2.9,3.2,6,3.6,9.4l15.6-7.5
					c-1-3.5-2.3-6.2-3.6-8.1c-2.1-3.3-4.1-5.1-5.3-6.1c-8.2-6.7-19.3-7-22.2-7.2c-2-0.1-4-0.1-6.1-0.1H0v49.8L16.9,41.7z"/>
				</svg>
				Denis Dev'n Design
			</a>
		</h1>
	</header>
</template>